export default "__VITE_ASSET__NibhKuv9__"